class BESSAppProjectEditorTagsInputField extends BESSAppProjectEditorSelectField {

    constructor(editor, item, field) {
        super(editor, item, field);
        BESSAppProjectEditorTagsInputField.#allFields.push(this);
    }

    _templateForInput() {
        return "<select multiple class='form-select field-editor app-validation-parent'></select>"
    }

    _configureView(node) {
        super._configureView(node);
        this.id = 'app-tags-' + uuid4();
        this.input.attr('id', this.id);
        this.node.addClass('app-field-tags');
        this.selectedTags = this.value.value !== null ? _.reverse([...this.value.value]) : [];
        this.selectedTagsOriginal = this.value.value !== null ? _.reverse([...this.value.value]) : [];
    }

    _addChoices() {
        this.input.attr('name', this.field.label + "[]");
        let tags = this.editor.data.tags;
        _.each(tags, function (tag) {
            this._addChoice(tag, tag);
        }.bind(this));
        this.allTags = [...tags];
    }

    initialise() {
        super.initialise();
        tags.init('#' + this.id, {
            allowNew: true,
            addOnBlur: true,
            allowClear: true,
            clearEnd: true,
            max: 10,
            selected: this.selectedTags,
            onSelectItem: function (x) {
                x = x.value;
                this.selectedTags.push(x);
                this.log("onSelectItem tags: ", this.selectedTags);
                this._inputChanged();
            }.bind(this),
            onClearItem: function (x) {
                this.selectedTags.splice(this.selectedTags.indexOf(x), 1);
                this.log("onClearItem tags: ", this.selectedTags);
                this._inputChanged();
                if (this.editor.data.tags.indexOf(x) === -1) {
                    BESSAppProjectEditorTagsInputField.#removedTag(this, x)
                }
            }.bind(this),
        });
        let el = document.querySelectorAll('#' + this.id)[0];
        this.tagsManager = tags.getInstance(el);
        this.log("this.tagsManager", this.tagsManager);
    }

    _getInputValue() {
        this._findNewTags();
        return this.selectedTags;
    }

    setValue(value) {
        this.selectedTags = value;
        this.log("setValue tags: ", this.selectedTags);
    }


    setValueIsChanged(value) {
        return !_.isEqual(value, this.selectedTagsOriginal);
    }

    _toDataValue(value) {
        return value;
    }

    _findNewTags() {
        let thisObj = this;
        this.input.find('option').each(function () {
            let option = $(this);
            if (option.is(":selected")) {
                let tag = option.attr('value');
                if (thisObj.selectedTags.indexOf(tag) === -1) {
                    thisObj.selectedTags.push(tag);
                    thisObj.log("_findNewTags, added " + tag);
                    BESSAppProjectEditorTagsInputField.#addedTag(thisObj, tag);
                }

            }

        });
    }


    static #allFields = [];

    static reset() {
        BESSAppProjectEditorTagsInputField.#allFields = [];
    }

    static #addedTag(input, tag) {
        if(input.editor.data.tags.indexOf(tag) !== -1) {
            return;
        }
        input.editor.data.tags.push(tag);
        input.editor.data.tags.sort();
        _.each(BESSAppProjectEditorTagsInputField.#allFields, function (x) {
            x.checkNeedsNewTagOption(input, tag);
        });
    }

    static #removedTag(input, tag) {
        if(input.editor.data.tags.indexOf(tag) === -1) {
            return;
        }

        input.editor.data.tags.splice(input.editor.data.tags.indexOf(tag), 1);
        _.each(BESSAppProjectEditorTagsInputField.#allFields, function (x) {
            x.removeTagOption(tag);
        });
    }

    checkNeedsNewTagOption(input, tag) {
        if (input === this) return;

        if (this.allTags.indexOf(tag) === -1) {
            this.allTags.push(tag);
            this._addChoice(tag, tag);
            this.tagsManager.resetSuggestions();
        }
    }

    removeTagOption(tag) {
        if (this.allTags.indexOf(tag) !== -1) {
            this.allTags.splice(this.allTags.indexOf(tag), 1);
            this._removeChoice(tag);
            this.tagsManager.resetSuggestions();
        }
    }
}